import axiosService from '../axios'

export const list = async () => {
  return axiosService({
    url: '/api.department',
    method: 'get',
  })
}
